import React, { lazy } from 'react';
import { MapPin } from 'lucide-react';
import { SectionReveal } from './ui/SectionReveal';
import { useLanguage } from '../context/LanguageContext';
export function IntroSection() {
  const {
    t
  } = useLanguage();
  return <SectionReveal id="proyecto" className="bg-sand-light pb-0" data-id="element-236">
      <div className="container mx-auto px-6 md:px-12" data-id="element-237">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-238">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-navy mb-8 leading-tight" data-id="element-239">
            {t.intro.title}
          </h2>
          <div className="space-y-6 text-navy/90 text-lg leading-relaxed" data-id="element-240">
            <p data-id="element-241">{t.intro.p1}</p>
            <p data-id="element-242">{t.intro.p2}</p>
          </div>
          <div className="w-24 h-[2px] bg-navy mx-auto mt-10" data-id="element-243"></div>
        </div>
      </div>

      {/* Full-width map */}
      <div className="relative w-full h-[60vh] min-h-[400px] bg-light" data-id="element-244">
        <iframe title="Ubicación de Residencial Aneto en Llano del Camello, Las Chafiras" src="https://www.google.com/maps?q=28.0576758,-16.6182603&z=17&output=embed" className="absolute inset-0 w-full h-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-id="element-245" />
        <a href="https://www.google.com/maps/place/28%C2%B003'27.6%22N+16%C2%B037'05.7%22W/@28.0576758,-16.6208352,17z/data=!3m1!4b1!4m4!3m3!8m2!3d28.0576758!4d-16.6182603" target="_blank" rel="noopener noreferrer" className="absolute bottom-8 left-1/2 -translate-x-1/2 inline-flex items-center gap-2 bg-navy text-white text-sm font-medium px-6 py-3 rounded-full shadow-xl hover:bg-navy-light transition-colors" data-id="element-246">
          <MapPin className="w-4 h-4 text-sand" data-id="element-247" />
          {t.intro.map}
        </a>
      </div>
    </SectionReveal>;
}